import Vue from "vue";
import Router, { RouterView } from "vue-router";
import { getToken } from "@/utils/auth";
import Layout from "@/layout";
import { Message } from "element-ui";
import store from "../store";

// 在文件顶部添加
let lastFetchTime = 0;
const CACHE_DURATION = 1 * 60 * 1000; // 5分钟缓存

Vue.use(Router);

const Empty = {
  render(h) {
    return h("router-view");
  },
};

// 公共路由
export const constantRoutes = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
  },
  {
    path: "*",
    component: () => import("@/views/error-page/404"),
    hidden: true,
  },
  {
    path: "/",
    redirect: "/creative-space/work-stats", // 默认进入创意空间 → 作品统计
    hidden: true,
  },

  // ====================== 创意空间 ======================
  {
    path: "/creative-space",
    component: Layout,
    redirect: "/creative-space/work-stats",
    name: "CreativeSpace",
    meta: { title: "创意空间", icon: "magic-stick", code: "admin.space" },
    children: [
      {
        path: "work-stats",
        name: "WorkStats",
        component: () => import("@/views/config/leave-type/index"),
        meta: { title: "作品统计", icon: "data-analysis", code: "admin.space.workstatic" },
      },
      {
        path: "checkin-stats",
        name: "CheckinStats",
        component: () => import("@/views/config/stamp-type/index"),
        meta: { title: "签到统计", icon: "calendar", code: "admin.space.checkinstatic" },
      },
      {
        path: "work-manage",
        name: "WorkManage",
        component: () => import("@/views/config/qrcode/index"),
        meta: { title: "作品管理", icon: "picture", code: "admin.space.workmanage" },
      },
      {
        path: "resource-manage",
        name: "ResourceManage",
        component: () => import("@/views/config/supplier/index"),
        meta: { title: "空间资源", icon: "box", code: "admin.space.resourcemanage" },
      },
      // {
      //   path: "child-file",
      //   name: "ChildFile",
      //   component: () => import("@/views/config/atype/index"),
      //   meta: { title: "儿童档案", icon: "reading", code: "admin.space.childfile" },
      // },
    ],
  },

  // ====================== 信息管理 ======================
  {
    path: "/info-management",
    component: Layout,
    redirect: "/info-management/child",
    name: "InfoManagement",
    meta: { title: "信息管理", icon: "user", code: "admin.info" },
    children: [
      {
        path: "child",
        name: "ChildManage",
        component: () => import("@/views/contact/staff/index"),
        meta: { title: "儿童管理", icon: "child", code: "admin.child.manage" },
      },
      {
        path: "graduate",
        name: "GraduateChild",
        component: () => import("@/views/contact/graduate/index"),
        meta: { title: "毕业儿童", icon: "school", code: "admin.child.graduate" },
      },
      {
        path: "class",
        name: "ClassManage",
        component: () => import("@/views/maintenance/record/index"),
        meta: { title: "班级管理", icon: "office-building", code: "admin.class.manage" },
      },
      // 职工管理 
      {
        path: "teacher",
        name: "StaffManage",
        component: () => import("@/views/material-management/category/index"),
        meta: { title: "职工管理", icon: "office-building", code: "admin.teacher.manage" },
      },
    ],
  },

  // ====================== 系统配置 ======================
  {
    path: "/system-config",
    component: Layout,
    redirect: "/system-config/grade",
    name: "SystemConfig",
    meta: { title: "系统配置", icon: "setting", code: "admin.config" },
    children: [
      {
        path: "grade",
        name: "GradeManage",
        component: () => import("@/views/admin/leave/index"),
        meta: { title: "年级管理", icon: "rank", code: "admin.grade.manage" },
      },
      {
        path: "iccard",
        name: "ICCardManage",
        component: () => import("@/views/contact/iccard/index"),
        meta: { title: "IC卡管理", icon: "credit-card", code: "admin.child.iccard" },
      },
      {
        path: "space",
        name: "SpaceManage2",
        component: () => import("@/views/config/department/index"),
        meta: { title: "空间配置", icon: "home-filled", code: "admin.space.spacemanage" },
      },
      {
        path: "field",
        name: "FieldManage",
        component: () => import("@/views/config/approval/index"),
        meta: { title: "领域配置", icon: "tickets", code: "admin.space.fieldmanage" },
      },
    ],
  },

  // ====================== 权限管理 ======================
  {
    path: "/permission",
    component: Layout,
    redirect: "/permission/role",
    name: "Permission",
    meta: { title: "权限管理", icon: "key", code: "admin.permission" },
    children: [
      {
        path: "role",
        name: "RoleManage",
        component: () => import("@/views/permission/role-permission/index"),
        meta: { title: "角色管理", icon: "lock", code: "admin.permission.role" },
      },
    ],
  },

  // ====================== 设置 ======================
  {
    path: "/system",
    component: Layout,
    redirect: "/system/personal",
    name: "System",
    meta: { title: "设置", icon: "tools", code: "admin.set" },
    children: [
      {
        path: "personal",
        name: "PersonalInfo",
        component: () => import("@/views/system/user/index"),
        meta: { title: "个人信息", icon: "user", code: "admin.set.personalInfo" },
      },
      {
        path: "version",
        name: "VersionManage",
        component: () => import("@/views/system/version/index"),
        meta: { title: "版本管理", icon: "document", code: "admin.version" },
      },
    ],
  },
];

const createRouter = () =>
  new Router({
    mode: "hash",
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

// 重置路由

router.beforeEach(async (to, from, next) => {
  const token = getToken();

  // 白名单路径直接放行
  if (to.path === "/login" || to.path === "/404") {
    return next();
  }

  // 无token统一跳转登录
  if (!token) {
    return next("/login");
  }

  // 获取用户权限
  const permissionStr = localStorage.getItem("user_permissions");
  const userPermissions = permissionStr ? JSON.parse(permissionStr) : [];
  const permissionCodeArr = [...new Set(userPermissions.map((p) => p.code))];

  // 获取公共数据（带缓存）
  // if (Date.now() - lastFetchTime > CACHE_DURATION) {
  try {
    await Promise.all([
      store.dispatch("getCodeList"),
      // store.dispatch("getDepartmentPage"),
      // store.dispatch("getSupplierList"),
    ]);
    lastFetchTime = Date.now();
  } catch (error) {
    console.error("获取公共数据失败:", error);
    // 即使获取失败也不应该阻止用户访问页面
  }
  // }
  // 权限检查
  const requiredCode = to.meta.code || "";

  // 如果该路由不需要权限码，直接放行
  if (!requiredCode) {
    return next();
  }

  // 如果有权限码且当前用户有该权限，放行
  if (permissionCodeArr.includes(requiredCode)) {
    return next();
  }

  // 没有权限
  Message.error("权限不足，无法访问该页面");
  next(false);
});

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

export default router;
